import { useValidation } from '@application/utils';
import { useMemo } from 'react';
import { boolean, object, string } from 'yup';

export const useValidationSchema = () => {
  const { emailMessage, isValidEmail, requiredMessage } = useValidation();

  const validationSchema = useMemo(() => {
    return object({
      firstName: string().required(requiredMessage),
      lastName: string().required(requiredMessage),
      email: string()
        .email(emailMessage)
        .required(requiredMessage)
        .test('is-valid-email', emailMessage, (value) => isValidEmail(value)),
      messageContent: string().required(requiredMessage),
      confirmedForm: boolean().isTrue(requiredMessage).required(requiredMessage),
    });
  }, [emailMessage, isValidEmail, requiredMessage]);

  return { validationSchema };
};
